import React from "react";
import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/antd";
import { TEAM_ONE_QUERY } from "./queries";
import { Typography } from "antd";
const { Text } = Typography;

interface ITeam {
  id: string;
  name: string;
  description?: string;
}

export const ShowTeam: React.FC = () => {
  const { query } = useShow<ITeam>({
    resource: "teams",
    meta: {
      gqlQuery: TEAM_ONE_QUERY,
    },
  });

  const { data, isLoading } = query;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Typography.Title level={5}>Name</Typography.Title>
      <Text>{record?.name}</Text>
      
      <Typography.Title level={5}>Description</Typography.Title>
      <Text>{record?.description || "-"}</Text>
      
      <Typography.Title level={5}>ID</Typography.Title>
      <Text>{record?.id}</Text>
    </Show>
  );
};